<template>
    <div id="specialtys-component">
        <b-modal v-model="showModal" hide-footer size="xl" centered scrollable :title="titleModal">
            <form id="formCrud" class="formCrud">
                <div class="row scr-gap-15-0">
                    <div class="col-12 col-md-6">
                        <input placeholder="Nombre de la especialidad" v-model="specialtys.especialidad" type="text"
                               class="al-inputs required scr-input" name="especialidad" id="especialidad"/>
                        <label for="especialidad" class="scr-supertext scr-extra">Nombre de la especialidad</label>
                    </div>
                    <div class="col-12 col-md-3 offset-md-3 col-xl-2 offset-xl-4">

                        <button id="dyn-button" type="button" class="formSubmit" v-on:click="guardar()">{{
                                tituloBtn
                            }}
                        </button>

                    </div>
                </div>
            </form>
        </b-modal>
        <main id="mainContent" class="padFixBoth">
            <div class="view">
                <div class="barSettings">
                    <div class="row">
                        <div class="col-12 col-xl-3 mb-3 mb-sm-0">
                           <b-pagination pills align="fill" :hide-goto-end-buttons="true" :limit="3" v-model="pagination.current_page"
                                          :total-rows="pagination.total" :per-page="pagination.per_page"
                                          aria-controls="my-table" v-on:change="onChange"></b-pagination>
                        </div>
                        <div class="col-12 col-xl-5 mb-3 mb-sm-0">
                            <input id="filter-input" class="al-inputs scr-input" v-model="filter" type="search"
                                   placeholder="Buscar por palabra">
                            <label for="filter-input" class="scr-supertext scr-extra">Buscar por palabra</label>
                        </div>
                        <div class="col-12 col-xl-2 mb-3 mb-sm-0 cont_select">
                            <select id="change_result" class="float" v-model="params.limit" v-on:change="changeLimit">
                                <option :value="10">10</option>
                                <option :value="20">20</option>
                                <option :value="30">30</option>
                                <option :value="50">50</option>
                                <option :value="100">100</option>
                            </select>
                        </div>
                        <div class="col-12 col-md-2 mb-3 mb-sm-0">
                            <button type="button" class="formSubmit" v-on:click="openModalsProviders()">{{
                                    tituloBtn
                                }}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="row">
                        <b-table responsive id="my-table" striped hover :fields="fields" :filter="filter" :busy="isBusy"
                                 :items="pagination.data">
                            <template #head(Acciones)="{item}">
                                <i class="fa-solid fa-gear"></i>
                            </template>
                            <!-- A virtual column -->
                            <template #cell(Especialidad)="data">
                                {{ data.item.especialidad }}
                            </template>
                            <template #cell(Acciones)="{item}">
                                <div class="dropdown">
                                    <button class="btn btn-warning dropdown-toggle" type="button"
                                            id="dropdownMenuButton"
                                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="fas fa-cogs"></i>
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <a class="dropdown-item" href="javascript:void(0)"
                                           v-on:click="modificar=true; updateReg(item)">Editar</a>
                                        <a class="dropdown-item" href="javascript:void(0)"
                                           v-on:click="onClickDelete(item.id)">Borrar</a>
                                    </div>
                                </div>
                            </template>
                            <template #table-busy>
                                <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Loading...</strong>
                                </div>
                            </template>
                        </b-table>
                    </div>
                </div>
            </div>

        </main>
    </div>
</template>

<script>
import {myMixins} from "../mixins/myMixins";
import {specialtysService} from "../../Services/Specialtys.service";

export default {
    name: "specialtys",
    mixins: [myMixins],
    data() {
        return {
            filter: null,
            show: false,
            isBusy: false,
            modificar: false,
            specialtys: {
                id: '',
                especialidad: '',
            },
            params: {
                limit: 10,
                page: 1,
            },
            fields: [
                {
                    key: 'Especialidad',
                },
                {
                    key: 'Acciones',
                }
            ],
            pagination: {
                current_page: 1,
                data: [],
                first_page_url: '',
                from: 0,
                last_page: 0,
                last_page_url: '',
                links: [],
                next_page_url: '',
                path: '',
                per_page: 0,
                prev_page_url: '',
                to: 0,
                total: 0,
            },
            tituloBtn: 'Agregar'
        }
    },
    methods: {
        async onClickDelete(id) {
            let resp = await specialtysService.deleteOne(id);
            this.getAlert(resp.process);
            await this.index();
        },
        updateReg(data = {}) {
            if (this.modificar) {
                this.tituloBtn = 'Actualizar'
                this.specialtys = data
            } else {
                this.tituloBtn = 'Agregar';
                this.setEmpty();
            }
        },
        async guardar() {

            let action = '';
            let respVal = this.valFormulariosV3();

            if (respVal) {
                this.disableSubmitBtn(true);
                if (this.modificar) {
                    this.resp = await specialtysService.updateOne(this.specialtys.id, this.specialtys);
                    action = 'update';
                } else {
                    this.resp = await specialtysService.saveOne(this.specialtys);
                    action = 'save';
                }
                this.disableSubmitBtn(false);
            }
            this.getAlert(this.resp.process, action);
            await this.index();
            this.modificar = false;
        },
        async index() {
            this.isBusy = true;
            this.pagination = await specialtysService.getMany(this.params);
            this.isBusy = false;
        },
        onChange(page) {
            this.params.page = page;
            this.index();
        },
        changeLimit() {
            this.index();
        },
        setEmpty() {
            this.specialtys = {
                id: '',
                especialidad: '',
            }
        }
    },
    mounted() {
        this.index();
    }
}
</script>

